// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"48c72031","116":"17634bae","310":"70e10ef1","523":"d263ab8b","589":"0170c13a","848":"f585c6f0"}[chunkId] + ".chunk.js";
};